import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { UserStorageService } from '../services/storage/user-storage.service';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.css'],
    standalone: false
})
export class MenuComponent {

  isAdmin: boolean = false;
  showAdminPanel: boolean = false;

  constructor(
    private router: Router,
    public authenticationService: AuthenticationService
  ) {
    this.isAdmin = UserStorageService.adminUser !== undefined && UserStorageService.adminUser.adminReplicated == '';
    this.showAdminPanel = UserStorageService.adminUser !== undefined;
  }

 // navigate back to the user's current homepage  
  toCurrentHome(): void {
    this.router.navigate([UserStorageService.currUser.currHomepage == '' && UserStorageService.adminUser ? 'no-trip-home' : UserStorageService.currUser.currHomepage]);
  }

  // navigate to the profile page
  toProfile(): void {

    this.router.navigate(['profile']);

  }

  // navigate to the records page
  toRecords(): void {

    this.router.navigate(['records-page']);

  }

  // navigate to the resources page
  toResources(): void {

    this.router.navigate(['resources']);

  }

  // navigate to the fishery notices page (not yet implemented)
  toFisheryNotices(): void {
    
    this.router.navigate(['fishery-notices']);
    
  }

  // log out of account and go back to login screen
  logout(): void {

    this.authenticationService.logout();

  }

  // navigate to the dev page (only used for development)
  toDevPage(): void {
    
    this.router.navigate(['dev']);
    
  }


  toHelp(): void {

    this.router.navigate(['help']);

  }

  toAdminPage(): void {

    this.router.navigate(['admin-panel']);

  }

}
